import { useState } from "react";
import { money } from "./api";

/* Every dish card is laid out for a photo. When there is none (or the file 404s),
   render a clean name-and-price tile — never a grey box, never a broken image icon. */
export const DishImg = ({ src, alt, name, price, className }) => {
  const [broken, setBroken] = useState(false);
  if (!src || broken) {
    if (!name) {
      return <div data-testid="dish-img-fallback" className={`${className} bg-gradient-to-br from-[#1C160A] via-[#121212] to-[#1A1208]`} />;
    }
    return (
      <div data-testid="dish-img-fallback"
        className={`${className} bg-[#1C160A] border border-[#D4AF37]/25 flex flex-col items-center justify-center text-center px-1.5`}>
        <span className="font-display font-bold text-[#D4AF37] text-[11px] leading-tight line-clamp-3">{name}</span>
        {price != null && <span className="text-white/70 text-[10px] font-bold mt-1">{money(price)}</span>}
      </div>
    );
  }
  return <img src={src} alt={alt || name} loading="lazy" className={className} onError={() => setBroken(true)} />;
};
